import { Dispatch } from 'react';
import {
  Claim,
  DrivingConviction,
  InsuranceJourneyDrivingHistoryDetailsType,
  MedicalCondition
} from '../../../components/common/CommonTypes';
import ActionTypes from '../ActionTypes';
import { initialInsuranceJourneyState } from '../../../consts/Common';

export const DrivingHistoryDetailsPageEventHandlers = (
  drivingHistoryDetails: InsuranceJourneyDrivingHistoryDetailsType,
  dispatch: Dispatch<ActionTypes>
) => {
  return {
    onChangeYearsLicenceHeld: (value: string) => {
      dispatch({
        type: 'set-driving-history-details',
        drivingHistoryDetails: {
          ...drivingHistoryDetails,
          yearsLicenceHeld: value
        }
      });
    },

    onChangeLicenceType: (value: string) => {
      dispatch({
        type: 'set-driving-history-details',
        drivingHistoryDetails: { ...drivingHistoryDetails, licenceType: value }
      });
    },

    onChangeHadClaimAccidentLosses: (value: boolean) => {
      dispatch({
        type: 'set-driving-history-details',
        drivingHistoryDetails: value
          ? {
              ...drivingHistoryDetails,
              hadClaimAccidentLosses: value
            }
          : {
              ...drivingHistoryDetails,
              hadClaimAccidentLosses: value,
              claims: initialInsuranceJourneyState.drivingHistoryDetails.claims
            }
      });
    },

    onChangeHadMedicalConditionOrDisabilities: (value: boolean) => {
      dispatch({
        type: 'set-driving-history-details',
        drivingHistoryDetails: value
          ? {
              ...drivingHistoryDetails,
              hadMedicalConditionOrDisabilities: value
            }
          : {
              ...drivingHistoryDetails,
              hadMedicalConditionOrDisabilities: value,
              medicalConditions:
                initialInsuranceJourneyState.drivingHistoryDetails
                  .medicalConditions
            }
      });
    },

    onChangeDeclinedInsurance: (value: boolean) => {
      dispatch({
        type: 'set-driving-history-details',
        drivingHistoryDetails: {
          ...drivingHistoryDetails,
          hadDeclinedInsurance: value
        }
      });
    },

    onChangeNonMotoringConvictions: (value: boolean) => {
      dispatch({
        type: 'set-driving-history-details',
        drivingHistoryDetails: {
          ...drivingHistoryDetails,
          hasNonMotoringConvictions: value
        }
      });
    },

    onChangeHadDrivingConvictions: (value: boolean) => {
      dispatch({
        type: 'set-driving-history-details',
        drivingHistoryDetails: value
          ? {
              ...drivingHistoryDetails,
              hadDrivingConvictions: value
            }
          : {
              ...drivingHistoryDetails,
              hadDrivingConvictions: value,
              drivingConvictions:
                initialInsuranceJourneyState.drivingHistoryDetails
                  .drivingConvictions
            }
      });
    },

    onChangeNoClaimBonusYears: (value: string) => {
      dispatch({
        type: 'set-driving-history-details',
        drivingHistoryDetails: {
          ...drivingHistoryDetails,
          noClaimsBonusYear: value
        }
      });
    },

    onUpdateClaims: (claims: Claim[]) => {
      dispatch({
        type: 'set-driving-history-details',
        drivingHistoryDetails: { ...drivingHistoryDetails, claims: [...claims] }
      });
    },

    onUpdateDrivingConvictions: (convictions: DrivingConviction[]) => {
      dispatch({
        type: 'set-driving-history-details',
        drivingHistoryDetails: {
          ...drivingHistoryDetails,
          drivingConvictions: [...convictions]
        }
      });
    },

    onUpdateMedicalConditions: (medicalConditions: MedicalCondition[]) => {
      dispatch({
        type: 'set-driving-history-details',
        drivingHistoryDetails: {
          ...drivingHistoryDetails,
          medicalConditions: [...medicalConditions]
        }
      });
    },

    onChangeNcdDiscount: (value: boolean) => {
      dispatch({
        type: 'set-driving-history-details',
        drivingHistoryDetails: {
          ...drivingHistoryDetails,
          ncdDiscount: value
        }
      });
    }
  };
};
